export const _Cart_Add = (product) => ({
  type: 'ADD_PRODUCT',
  product
});

export const _Cart_Remove = (product) => {
  product.credit = 0;
  return {
    type: 'REMOVE_PRODUCT',
    product
  };
};

export const _Cart_Update = (cart) => ({
  type: 'UPDATE_CART',
  cart
});

export const _Cart_Clean = () => ({
  type: 'CLEAN_CART'
});

export const _Cart_Decrease = (product_id) => ({
  type: 'DECREASE_PRODUCT',
  product_id
});

export const _Delivery = (address_id) => ({
  type: 'DELIVERY_OPTIONS',
  address_id
});
